import { render, staticRenderFns } from "./item-approved.vue?vue&type=template&id=6b02c369&scoped=true&"
import script from "./item-approved.vue?vue&type=script&lang=js&"
export * from "./item-approved.vue?vue&type=script&lang=js&"
import style0 from "./item-approved.vue?vue&type=style&index=0&id=6b02c369&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b02c369",
  null
  
)

export default component.exports